<template>
  <div>
    <div class="va-row">
      <div class="flex md12 xs12">
        <div class="form-group">
          <div class="input-group">
            <vuestic-date-picker
              :value="date"
              :config="{clickOpens: !this.readonly, dateFormat:this.dateFormat, locale: { firstDayOfWeek: 1 }}"
            ></vuestic-date-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserDate } from '../../../helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'date-cell',
  props: {
    value: {
      reqiured: true
    },
    id: {
      default: ''
    },
    classes: {
      default: () => []
    },
    readonly: {
      default: false
    },
    name: {
      type: String
    },
    dateFormat: {
      default: () => 'd-m-Y'
    },
    onChange: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('app', {
      userDateFormat: 'dateFormat',
      serverDateFormat: 'serverDateFormat'
    }),
    date () {
      return getUserDate(this.value)
    }
  },
  methods: {
    onChangeInternal: function (date) {
      this.onChange({
        type: 'date',
        name: this.name,
        value: date[0].getTime(),
        id: this.rowData.id
      })
    }
  }
}
</script>

<style scoped>
</style>
